import { Component } from '@angular/core';

import { ModalController } from '@ionic/angular';
import { ContentService } from '../services/content.service';

@Component({
  selector: 'app-modal-department',
  templateUrl: 'department-modal.html',
  styleUrls: ['department-moda.scss'],
})
export class DepartmentModal {
    name:string;
    states = [];
    departments = [];
    departmentSelected = 0;

    constructor(
        private modalCtrl: ModalController,
        private contentService: ContentService
    ) {
        this.contentService.getStates()
            .subscribe( (states: any) => {
                console.log( states )
                this.states = states
            })
    }

    cancel() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    confirm() {
        return this.modalCtrl.dismiss(this.departmentSelected, 'confirm');
    }

    selectProvincia(e) {
        console.log(e.target.value);
        this.contentService.getDepartment( e.target.value )
            .subscribe( (departments: any) => {
                console.log( departments)
                this.departments = departments
            })
    }

    selectDepartment(e){
        this.departmentSelected = e.target.value
    }
}